import differenceInDays from "date-fns/differenceInDays";
import isBefore from "date-fns/isBefore";

function getProgressBetweenDates(startDate, endDate) {
  if (!endDate) {
    return isBefore(startDate, new Date()) ? "100%" : "0%";
  }

  let totalDays = Math.ceil(differenceInDays(endDate, startDate), 0);
  let daysSinceStartDate = Math.ceil(
    differenceInDays(new Date(), startDate),
    0
  );
  let progress = (daysSinceStartDate / totalDays) * 100;

  // Ensure the value never exceeds 100%
  return Math.min(progress, 100);
}

export { getProgressBetweenDates };
